import { useQuery } from '@tanstack/react-query';
import { Pageable } from 'shared/model';

import { getMemberNotification, getReviewDetail, getReviewExists } from './service';

export const useGetMemberNotification = (pageable?: Pageable) => {
  return useQuery({
    queryKey: ['memberNotification', pageable],

    queryFn: () => getMemberNotification(pageable),
  });
};

export const useGetReviewDetail = ({ enabled, orderId }: { enabled: boolean; orderId: number }) => {
  return useQuery({
    queryKey: ['reviewDetail', orderId],
    queryFn: () => getReviewDetail(orderId),
    enabled,
  });
};

export const useGetReviewExists = (orderId: number) => {
  return useQuery({
    queryKey: ['reviewExists', orderId],
    queryFn: () => getReviewExists(orderId),
    enabled: !!orderId,
  });
};
